export const selectDashboardLoading = (state) => state?.dashboard?.loading;
export const selectDashboardsData = (state) => state?.dashboard?.dashboardData;

export const selectDashboardChartLoading = (state) =>
  state?.dashboard?.chartLoading;
export const selectDashboardChartData = (state) =>
  state?.dashboard?.dashboardChartData;
